import React from "react";
import { ReactComponent as InformationCircle } from "images/icons/information-circle.svg";
import { StorefrontConfig } from "../types/storefront";
import { I18n } from "i18n-js";

const UnsupportedFulfillmentMethodBanner = ({
  config,
  i18n,
}: {
  config: StorefrontConfig;
  i18n: I18n;
}): React.JSX.Element => {
  return <div className="container space-mt-lg">
    <div className="callout has-coloured-icon">
      <InformationCircle className="icon streamline-icon"/>
      <div>
        <div className="title">
          {i18n.t("customer.storefront.fulfillment_method.not_supported.customer_pickup.title")}
        </div>

        <p>
          {i18n.t("customer.storefront.fulfillment_method.not_supported.customer_pickup.description")}
        </p>
      </div>
    </div>
    <div>
      <form action="/restaurants/change_delivery_type" method="post">
        <input
          type="hidden"
          name="authenticity_token"
          autoComplete="off"
          value={config.csrfToken}
        />

        <input
          type="hidden"
          name="redirect_to"
          autoComplete="off"
          value={window.location.href}
        />

        <input
          type="hidden"
          name="storefront_id"
          autoComplete="off"
          value={config.storefrontId}
        />
        <input
          type="hidden"
          name="fulfillment_method"
          id="fulfillment_method_delivery"
          value="delivery"
        />

        <input
          type="submit"
          name="fulfillment_method"
          id="fulfillment_method_delivery"
          value="View for delivery"
          className="button is-primary space-mr-sm space-mt-sm"
        />
        <a className="button space-mt-sm" href="/">
          <span>See pickup stores</span>
        </a>
      </form>
    </div>
  </div>
}

export { UnsupportedFulfillmentMethodBanner }